"use client";

// biome-ignore lint/nursery/noDeprecatedImports: upstream Contentful hook is still required for live preview updates
import { useContentfulLiveUpdates } from "@scott/contentful/live-preview-init";
import { DivisionsPreview } from "@/scott/ui/blocks/divisions/divisions.preview";
import {
  adaptDivisionNavigation,
  type DivisionNavigationInput,
} from "@/services/contentful/assemblies/division-navigation/division-navigation.adapter";
import { DivisionNavigationDocument } from "@/services/contentful/generated/contentful-sdk.generated";
import { debugWarn } from "@/utils/debug";

type DivisionNavigationLivePreviewProps = {
  assembly: DivisionNavigationInput;
  /** The active market's `/{country}/{lang}`, for internal page links. */
  basePath: string;
  locale: string;
};

export function DivisionNavigationLivePreview(
  props: Readonly<DivisionNavigationLivePreviewProps>
) {
  const updatedAssembly = useContentfulLiveUpdates(props.assembly, {
    locale: props.locale,
    query: DivisionNavigationDocument,
  });

  try {
    const divisionNavigation = adaptDivisionNavigation(
      updatedAssembly,
      props.basePath
    );

    if (!divisionNavigation) {
      return null;
    }

    return (
      <DivisionsPreview
        ariaLabel={divisionNavigation.ariaLabel}
        divisions={divisionNavigation.divisions}
        sys={updatedAssembly.sys}
      />
    );
  } catch (error) {
    debugWarn("CONTENTFUL - live Division Navigation adaptation failed", {
      entryId: updatedAssembly.sys?.id,
      locale: props.locale,
      error,
    });
    return null;
  }
}
